import { isEmpty } from 'lodash-es'

export default function(targetObject) {
  return Object.values(targetObject).filter((val) => !isEmpty(val)).length === 0
}
